module.exports = __webpack_public_path__ + "img/chat-quote-fill.af7558ff.svg";